import { h } from 'preact';
import React from 'preact/compat';

import { Translate } from '@travel/translation';

import { Area } from 'Common-Types';
import Link from 'core/universalRouter/Link';
import { InternalLink } from 'HotelList-Types';

import { labelTypes } from 'constants/seo';
import paths from 'constants/paths';

import styles from '../internalLinks.module.scss';

export type Props = {
  data: Array<InternalLink>;
  heading: string;
};

const InternalLinksPcData = (props: Props) => {
  const { data, heading } = props;

  return (
    <div data-testId="internalLinksCard-container-div" className={styles.displayContainer}>
      <span className={styles.bottomSpacing}>
        <Translate id="Domestic.JRDP.Internal_Link_Label.Title" data={{ subivision: heading }} />
      </span>
      {data.map((internalLink: InternalLink, index) => {
        return (
          <div className={styles.extraBottomSpacing} key={`${internalLink.type}-${index}`}>
            <Translate
              className={styles.accordionTitle}
              id={`Domestic.JRDP.Internal_Link_Label.${labelTypes[internalLink.type]}`}
              data={{ subdivision: heading }}
            />
            <div className={styles.accordionContentContainer}>
              {internalLink.places?.map((place: Area, index: number) => {
                const lastChild = internalLink?.places?.length - 1 === index;
                return (
                  <Link
                    key={index}
                    to={paths.providerList.pathResolver(place.pathId)}
                    className={styles.accordionContent}
                    data-testid="InternalLinksPcData-section-link"
                  >
                    <span>
                      {place.name}
                      {!lastChild && <span className={styles.verticalDivider}>|</span>}
                    </span>
                  </Link>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(InternalLinksPcData);
